
import React from "react";
import PrivateHero from "../components/privateHypno/PrivateHero";
import HypnoContent from "../components/privateHypno/HypnoContent";



const PrivateHypnotherapy = () => {

  return (
<>
<PrivateHero/>
<HypnoContent/>
</>
  );
};

export default PrivateHypnotherapy;
